import { NodeNames } from '@farmersdog/constants';

import { getNodeById, getNodeNameAndPosition } from '../blueprint/utils';

import { getSignupRouteFromDetails } from './getSignupRouteFromDetails';

import type { NodeRegistry } from '../blueprint/types';
import type { UseForm } from '../types';

export enum SearchParams {
  Card = 'card',
  Pet = 'pet',
}

interface getSignupRouteArgs {
  registry: NodeRegistry | undefined;
  current: string | undefined;
  getValues: UseForm['getValues'];
}

export function getSignupRoute({
  registry,
  current,
  getValues,
}: getSignupRouteArgs) {
  if (!registry || !current) {
    return;
  }

  const node = getNodeById(current, registry);

  if (!node?.route) {
    // This is preserving existing behavior; unclear if it's ever happening in
    // practice, but it happens in tests
    // See https://github.com/farmersdog/beethoven/blob/ebf6a592957aee8a374a96bebc727c63986a7dd5/domains/website/tosa/src/utils/getSignupRoute.ts#L30
    return '?';
  }

  const pathname = node.route;
  const { name: cardName, position } = getNodeNameAndPosition(node.name);

  const petNameField = `${NodeNames.Name}-${position}` as const;
  const petName = getValues(petNameField);

  return getSignupRouteFromDetails({
    route: pathname,
    cardName,
    petName,
  });
}
